import React from "react";
import { TouchableOpacity, Text, View } from "react-native";
import { isWeb } from "../../../../helpers/utils";

import appStyles from "../../../appStyles";
import fontStyles from "../../../fonts";
import AppTheme from "../../AppTheme";
import RoundCheckbox from "../../common/RoundCheckbox";

export default function TrackHomeSelectAllSection(props) {
  const { timeslotsCount, journalContext } = props || {};

  const {
    isBulkEdit,
    bulkSelectedIds,
    toggleBulkSelection = () => {},
  } = journalContext || {};

  const selectedCount = Object.keys(bulkSelectedIds).length;
  const isFullSelected = selectedCount > 0 && selectedCount == timeslotsCount;
  const isPartial = selectedCount > 0 && selectedCount != timeslotsCount;

  return isBulkEdit ? (
    <TouchableOpacity
      onPress={() => toggleBulkSelection(!(isFullSelected || isPartial))}
      style={{
        height: 48,
        paddingTop: 8,
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: AppTheme.containerBg,
        paddingRight: isWeb ? 8 : 0,
      }}
    >
      <Text style={[fontStyles.h4, { color: "#8B92A1" }]}>
        Select Timeslots
      </Text>
      <RoundCheckbox
        size={16}
        checked={isFullSelected}
        hasChildrenChecked={isPartial}
        onValueChange={toggleBulkSelection}
      />
    </TouchableOpacity>
  ) : (
    <View style={appStyles.preList} />
  );
}
